// @ts-nocheck
import styled from "@emotion/styled";
import {
  Autocomplete,
  Grid,
  OutlinedInput,
  Paper,
  TextField,
  Typography,
  TextareaAutosize,
} from "@mui/material";
import { CustomInfoButton } from "./CustomIconButton";
import Star from "../../assets/images/star.svg";

export const CustomInput = styled((props) => (
  <OutlinedInput
    inputProps={{
      "aria-label": "weight",
    }}
    {...props}
  />
))(({ theme }) => ({
  color: "white",
  height: "50px",
  "& fieldset": {
    borderColor: "white !important",
    borderRadius: "6px",
  },
}));

export const CustomTextFiled = styled((props) => (
  <TextField
    inputProps={{
      "aria-label": "weight",
    }}
    InputProps={{
      style: {
        color: "white",
        ...props?.style,
      },
    }}
    {...props}
  />
))(({ theme, multiline }) => ({
  color: "white",
  ...(multiline
    ? {}
    : {
        height: "50px",
      }),
  "& fieldset": {
    borderColor: "white !important",
    borderRadius: "10px",
  },
}));

export const CustomTextArea = styled((props) => {
  const { sx, ...rest } = props;
  return (
    <TextareaAutosize
      inputProps={{
        "aria-label": "weight",
      }}
      style={{
        color: "white",
        background: "transparent",
        fontFamily: "inherit !important",
        ...(sx || {}),
      }}
      InputProps={{
        sx: {},
      }}
      {...rest}
    />
  );
})(({ theme }) => ({
  color: "white",
  height: "50px",
  "& fieldset": {
    borderColor: "white !important",
    borderRadius: "10px",
  },
}));

export const CustomSelectInput = styled((props) => (
  <Autocomplete
    multiple
    freeSolo
    // NOTE: Autocomplete has no `inputProps` prop — the old aria-label object
    // fell through to the root <div> and React warned about the unknown
    // `inputProps` DOM attribute. Input a11y props belong on the TextField
    // inside renderInput.
    {...props}
  />
))(({ theme }) => ({
  color: "white",
  height: "50px",
  "& fieldset": {
    borderColor: "white !important",
    borderRadius: "10px",
  },
}));

export const CustomDropdownInput = styled((props) => (
  <Autocomplete
    inputProps={{
      "aria-label": "weight",
    }}
    autoComplete={true}
    clearIcon={true}
    clearOnEscape={true}
    disableClearable
    autoHighlight
    renderInput={(params) => (
      <CustomTextFiled
        {...params}
        inputProps={{ ...params.inputProps }}
        placeholder={props?.inputPlaceholder}
      />
    )}
    renderOption={(props, option) => {
      return (
        <Grid
          key={option?._id}
          container
          style={{
            gap: "10px",
            border: "1px solid #D175B6",
            borderRadius: "12px",
            marginBottom: "10px",
          }}
          {...props}
        >
          <Grid container item xs={11}>
            <Grid item>
              <Typography
                style={{ color: "white", fontSize: "20px", fontWeight: "500" }}
              >
                {option?.position}
                {/* NOTE: some demo text */}
                <span
                  style={{
                    display: "inline-flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#D175B6",
                    fontSize: "16px",
                    fontWeight: "300",
                  }}
                >
                  <img
                    src={Star}
                    style={{
                      marginLeft: "10px",
                      marginRight: "10px",
                    }}
                    alt="star"
                  />
                  {"Audio"}
                </span>
              </Typography>
              <Typography
                style={{ color: "white", fontSize: "12px", fontWeight: "300" }}
              >
                {option?.positionDescription}
              </Typography>
            </Grid>
          </Grid>
          <CustomInfoButton
            header={option?.position}
            body={option?.positionDescription}
            equipments={option?.equipmentRequired}
          />
        </Grid>
      );
    }}
    PaperComponent={({ children }) => (
      <Paper
        style={{
          backgroundColor: "rgba(0, 0, 0, 1)",
          borderRadius: "12px",
          border: "1px solid #D175B6",
          zIndex: 20,
          width: "35vw",
          padding: "10px",
        }}
      >
        {children}
      </Paper>
    )}
    {...props}
  />
))(({ theme }) => ({
  color: "white",
  height: "50px",
  "& fieldset": {
    borderColor: "white !important",
    borderRadius: "10px",
  },
}));